import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import 'rxjs/add/operator/catch';



import { AdmincrashreportService } from 'api/admincrashreport/admincrashreport.service';


declare var $: any;
declare var jQuery: any;


@Component({
    selector: 'admincrashreport-page',
    templateUrl: './admincrashreport.html'
})

export class AdminCrashreport implements OnInit {


    crashList: any;
    message: any
    constructor(private AdmincrashreportService: AdmincrashreportService, private router: Router) {
    }

    ngOnInit() {

        if (localStorage.getItem('token')) {
            $(function () {
            })
            this.initData();
        } else {
            this.router.navigate(['/']);
        }
    }

    initData() {
        this.AdmincrashreportService.allAdmincrashreport().then(data => {
            if (data.status) {
                this.crashList = data.data
            }

        })

    }
    Showdetails(crashes) {
        this.message = crashes.message
    }
    deleteSure() {
        this.AdmincrashreportService.deleteAdmincrashreport().then(data => {
            if (data.status) {
                this.crashList = []
                $.notify({
                    message: data.message
                }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
                $(function () {
                    $('#deleteSureModal').modal('toggle');
                });
            } else {
                $.notify({
                    message: data.message
                }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'right'
                        },
                        delay: 100,
                        timer: 100
                    });
            }

        })
    }
}




// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/admincrashreport/admincrashreport.page.ts